import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faLink, faFile, faStickyNote, faCapsules } from '@fortawesome/free-solid-svg-icons';

library.add(faPlus, faLink, faFile, faStickyNote, faCapsules);
